type IRoutes = "signin" | "signup" | "unauthoried" | "loading" | "success";
type IRoutesKey = "SIGNIN" | "SIGNUP" | "UNAUTHRIZED_DOMAIN" | "LOADING" | "SUCCESS";

export const ROUTES: { [key in IRoutesKey]: IRoutes } = {
  SIGNIN: "signin",
  SIGNUP: "signup",
  UNAUTHRIZED_DOMAIN: "unauthoried",
  LOADING: "loading",
  SUCCESS:'success'
};
